export default "__VITE_ASSET__C1QYm7t3__"